import React, { useState, useEffect } from "react";
import InputData from "./InputData";
import Dropdown from "./Dropdown";
import ButtonIconH from "./ButtonIconH";
import "../css/ProductStockAdjustment.css";
import { selectedOptic, userData } from "../js/utils";
import { post } from "../js/post";

export default function ProductStockAdjustment(props) {
  const [reasonList, setReasonList] = useState([]);
  const [selectedReason, setSelectedReason] = useState({ id: "", text: "" });
  const [stock, setStock] = useState(0);

  // console.log("MOTIVOS: ", reasonList, selectedReason);

  async function getReasons() {
    const response = await post("ListarMotivosAjusteStock.php", {
      token: userData.token,
    });
    setReasonList([
      { id: "", text: "" },
      ...response.map((e) => ({ id: e.id, text: e.descripcion })),
    ]);
  }

  async function adjustProductStock() {
    await post("AjustarStockProducto.php", {
      token: userData.token,
      codigo: props.productCode,
      idOptica: selectedOptic.id,
      motivo: selectedReason.text,
      stock: stock,
    });
  }

  useEffect(() => {
    getReasons();
  }, []);

  useEffect(() => {
    setStock(0);
    setSelectedReason({ id: "", text: "" });
  }, [props.productCode]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        alignItems: "center",
        marginBottom: "20px",
      }}
    >
      <div className="product-stock-container">
        <button
          onClick={() => {
            setStock(stock - 1);
          }}
        >
          -
        </button>
        <div className="data-field">
          <InputData
            tabIndex={10}
            type="type-integer"
            size={5}
            input={stock}
            onChange={(e) => {
              const value = parseInt(e);
              setStock(isNaN(value) ? 0 : value);
            }}
          ></InputData>
        </div>
        <button
          onClick={() => {
            setStock(stock + 1);
          }}
        >
          +
        </button>
      </div>
      <div className="data-field">
        <span className="cell-label">Motivo</span>
        <Dropdown
          tabIndex={7}
          id="provincia"
          disabled={false}
          optionList={reasonList}
          size={2}
          op={selectedReason.id}
          onChange={(e) => {
            setSelectedReason(e);
          }}
        ></Dropdown>
      </div>
      <ButtonIconH
        text="Aceptar"
        small={true}
        disabled={stock === 0 || !selectedReason.id}
        onClick={async () => {
          await adjustProductStock();
          props.onAccept();
          props.createPopupQuestion(
            "El ajuste de stock se ha realizado correctamente. Puede consultarse en la sección de trazabilidad del producto.",
            () => {
              props.removePopupQuestion();
              setSelectedReason({ id: "", text: "" });
              setStock(0);
            },
            null,
            "Aceptar",
          );
        }}
      ></ButtonIconH>
    </div>
  );
}
